var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('vs-button',{staticClass:"btn-theme",attrs:{"flat":"","icon":"","warn":_vm.isDarkModeActive,"dark":!_vm.isDarkModeActive},on:{"click":_vm.toggleTheme}},[_c('i',{class:`ti ${!_vm.isDarkModeActive ? 'ti-moon-filled' : 'ti-sun-filled'}`})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }